import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { ListBoxItem as AriaListBoxItem, Text } from "react-aria-components";
import { Check } from "../icons/line.js";
import { checkedIcon, item, itemIcon, itemText, itemWrapper } from "./ListBoxItem.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseListBoxItem = (t0, ref) => {
  const $ = _c(11);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const left = props.left ?? props.icon;
  let t1;
  if ($[3] !== children || $[4] !== left) {
    t1 = t2 => {
      const {
        isSelected,
        isFocused,
        isDisabled
      } = t2;
      return /*#__PURE__*/_jsxs("div", {
        className: item({
          isFocused,
          isSelected,
          isDisabled
        }),
        title: children,
        children: [typeof left === "function" ? /*#__PURE__*/React.createElement(left, {
          className: itemIcon
        }) : left, /*#__PURE__*/_jsx(Text, {
          className: itemText,
          slot: "label",
          children: children
        }), isSelected && /*#__PURE__*/_jsx(Check, {
          className: checkedIcon
        })]
      });
    };
    $[3] = children;
    $[4] = left;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t1) {
    t2 = /*#__PURE__*/_jsx(AriaListBoxItem, {
      textValue: children,
      ...props,
      className: itemWrapper,
      ref: ref,
      children: t1
    });
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export const ListBoxItem = /*#__PURE__*/React.forwardRef(BaseListBoxItem);
//# sourceMappingURL=ListBoxItem.js.map